<template>
  <Popper
    placement="top"
    :hover="!isMobile"
    :arrow="true"
    offset-distance="6"
  >
    <button
      class="h-4 w-4 flex-shrink-0 hover:opacity-80"
      type="button"
      tabindex="-1"
    >
      <img
        src="@/assets/info-icon.svg"
        alt="info icon"
        class="ml-2"
      />
    </button>

    <template #content>
      <div
        class="w-72 px-2 py-1 sm:w-96"
        style="max-width: 100%"
      >
        <div
          class="w-full rounded-md px-2 py-1 text-left text-2xs shadow-sm"
          :class="contentClass"
        >
          <slot />
        </div>
      </div>
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper';

export default {
  components: {
    Popper,
  },
  props: {
    colorScheme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMobile: window.innerWidth <= 1024,
    };
  },
  computed: {
    contentClass() {
      if (this.colorScheme == 'light') {
        return 'text-dark-gray bg-light-gray';
      } else {
        return 'text-white bg-dark-gray';
      }
    },
  },
};
</script>

<style scoped>
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 16px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
